<template>
  <x-page title="">
    <XOrderSwitcher slot="title" />

    <x-sticky>
      <van-tabs
        v-model="currentCategoryIndex"
        :class="_.tabs"
        title-active-color="rgba(255, 17, 28, 1)"
        @click="
          index =>
            $track.push({
              name: '我的订单-分类栏',
              content: categoryList[index].label,
              id: '3d14e2c4-85c4-44f2-bc80-e0f4ea73481a',
            })
        "
      >
        <van-tab
          v-for="cat in categoryList"
          :key="cat.value"
          :title="cat.label"
        />
      </van-tabs>
    </x-sticky>

    <x-swipeable-view
      :index="currentCategoryIndex"
      :total="categoryList.length"
      @swipe="({ index }) => (currentCategoryIndex = index)"
    >
      <AfterSalesList v-if="is售后" :embed="true" :no-complete-tips="true" />

      <BookOrderList
        v-else-if="is标销"
        :embed="true"
        :no-complete-tips="true"
        :active-index="2"
      />

      <div v-else :class="_.list">
        <x-waterfall
          ref="list"
          no-complete-tips
          primary-key="orderNo"
          :load="handleLoad"
          :check="handleCheck"
        >
          <template #default="{ data, record }">
            <OrderItem
              v-for="item in data"
              :key="item.orderNo"
              :item="item"
              @click="() => record(item.orderNo)"
              @refresh="reloadList"
            />
          </template>
          <x-empty slot="empty" type="列表" message="暂时没有订单哦~" />
          <x-goods-recommend
            v-if="$globalModel.state.channelIsShowDcbResource"
            slot="extra"
            resource-position-id="8aaa8ac37b113694017b1143da8d001a"
            :top="0"
          />
        </x-waterfall>
      </div>
    </x-swipeable-view>
  </x-page>
</template>

<script>
  import AfterSalesList from '@/views/after_sales/index.vue'
  import BookOrderList from '@/views/book/order/index.vue'
  import OrderItem from './components/order_item'
  import Vue from 'vue'
  import { apiOrderOrderList } from '@/api'
  import { mapQuery, Track } from '@/utils'
  import { wait } from 'vtils'

  export default Vue.extend({
    components: {
      OrderItem,
      AfterSalesList,
      BookOrderList,
    },

    mixins: [
      mapQuery({
        active: 'active',
      }),
      Track.provideMark(() => ({
        page: '我的订单',
      })),
    ],

    data() {
      return {
        // 当前分类索引
        currentCategoryIndex: 0,

        // 分类列表
        categoryList: [
          {
            label: '全部',
            value: 0,
          },
          {
            label: '待付款',
            value: 1,
          },
          {
            label: '待发货',
            value: 2,
          },
          {
            label: '待收货',
            value: 3,
          },
          {
            label: '待使用',
            value: 6,
          },
          {
            label: '待评价',
            value: 4,
          },
          {
            label: '退款/售后',
            value: 5,
          },
        ],
      }
    },

    computed: {
      is售后() {
        return this.categoryList[this.currentCategoryIndex].value === 5
      },
      is标销() {
        return this.categoryList[this.currentCategoryIndex].value === 6
      },
    },

    watch: {
      currentCategoryIndex() {
        this.reloadList()
      },
    },

    created() {
      this.currentCategoryIndex = +(this.active || 0)
    },

    methods: {
      // 重载列表
      async reloadList() {
        await wait(1000)
        await this.$refs.list.reload()
      },

      // 加载列表
      handleLoad({ pageNumber }) {
        return apiOrderOrderList({
          pageIndex: pageNumber,
          pageSize: 10,
          status: this.categoryList[this.currentCategoryIndex].value,
        })
      },

      // 检查订单
      async handleCheck(item) {
        const {
          list: [newItem],
        } = await apiOrderOrderList({
          pageIndex: 1,
          pageSize: 1,
          status: this.categoryList[this.currentCategoryIndex].value,
          orderNo: item.orderNo,
        })
        return newItem
      },
    },
  })
</script>

<style lang="scss" module>
  .tabs {
    z-index: 1;
  }

  .list {
    padding: 12px;
  }
</style>
